<script setup>
defineProps({
  title: {
    type: String,
    default: 'Tab',
  },
  icon: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <slot />
</template>
